// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__194_e","name":"ConsentHeader_name__1y_oP","birthday":"ConsentHeader_birthday__21W1s","skeleton":"ConsentHeader_skeleton__18Pti"};